import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getPartnerLogs = (req) => {
    return vdkEmHappinessPortalApi.post('/partner-logs/get-all', req);
};
const partnerLogAPI = { getPartnerLogs };
export default partnerLogAPI;
